import { api } from '@/lib/trpc/react';
import * as Sentry from '@sentry/nextjs';
import { deleteCookie, getCookie } from 'cookies-next';
import { atom, useAtom } from 'jotai';
import { useCallback, useEffect } from 'react';

export const isAdminAtom = atom(false);

export const useImpersonation = () => {
  const [isAdmin, setIsAdmin] = useAtom(isAdminAtom);

  const { mutateAsync } = api.admin.exitImpersonation.useMutation();
  const { mutateAsync: verifyAdminMutation } =
    api.admin.verifyAdmin.useMutation();

  const checkAdmin = useCallback(
    async (email: string) => {
      const adminImpersonationJwt = getCookie('admin-impersonation');

      if (!adminImpersonationJwt) return false;

      const admin = await verifyAdminMutation(
        adminImpersonationJwt as string,
      ).catch(() => {
        deleteCookie('admin-impersonation');
        Sentry.captureMessage(
          `Admin impersonation verifcation failed, for impersonating ${email}`,
        );
        return null;
      });

      return !!admin;
    },
    [verifyAdminMutation],
  );

  useEffect(() => {
    const impersonatedAdmin = getCookie('admin-impersonation');
    if (impersonatedAdmin) {
      setIsAdmin(true);
    }
  }, []);

  const exitImpersonation = async () => {
    const impersonatedAdmin = getCookie('admin-impersonation');

    if (!impersonatedAdmin) {
      return;
    }

    await mutateAsync(impersonatedAdmin);
    deleteCookie('admin-impersonation');

    window.location.reload();
  };

  return {
    isAdmin,
    checkAdmin,
    exitImpersonation,
  };
};
